import { IMovementPlanSummary } from "domain/Inventory/Models/IMovementPlanSummary";
import { SBTranslate } from "i18n";
import { SBBox } from "modules/Commons";
import { useEffect, useState } from "react";
import SBSummarization from "views/Commons/SBSummarization";

export default ({ items, summaryBase }: DistributionSummarizationProps) => {
	const [summarizations, setSummarizations] = useState<any>([]);

	const returnFinalValue = (
		array: any,
		field: string,
		summaryBaseKey?: keyof IMovementPlanSummary,
	) => {
		var localModifierValue = 0;
		if (field === "amount") {
			for (const a of array) {
				localModifierValue += (a.modifier || 0);
			}
		}

		let baseValue = 0;
		if (summaryBase && summaryBaseKey) {
			baseValue = summaryBase[summaryBaseKey] || 0;
		} else {
			for (const a of array) {
				baseValue += (a[field] || 0);
			}
		}

		return baseValue + localModifierValue;
	};

	useEffect(() => {
		setSummarizations([
			{
				name: SBTranslate("distributionUnit"),
				tip: SBTranslate("tips.distributionUnit"),
				icon: "package",
				color: "darkPurple",
				value: returnFinalValue(items, "amount", "totalUnits"),
			},
			{
				name: SBTranslate("volumeTotal"),
				tip: SBTranslate("tips.volumeTotal"),
				icon: "maximize-2",
				color: "darkPurple",
				value: returnFinalValue(items, "volume", "totalVolume"),
			},
			{
				name: SBTranslate("stores"),
				tip: SBTranslate("tips.storeDistribution"),
				icon: "home",
				color: "darkPurple",
				value: returnFinalValue(items, "storeQuantity", "totalStores"),
			},
		]);
	}, [items, summaryBase]);

	return (
		<SBBox my={2}>
			<SBSummarization items={summarizations} withShadow />
		</SBBox>
	);
};

interface DistributionSummarizationProps {
	items: any[];
	summaryBase?: IMovementPlanSummary;
}
